import {
  assign,
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const togglePublishedMarkCompleteTranstion: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "togglePublishedMarkComplete",
    src: "togglePublishedMarkComplete",
    onDone: {
      target: "#StudyPlan.get_current_plan"
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("togglePublishedMarkComplete", {
            messageData: ["toggle mark complete"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
